import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.1533 35.3941L21.6389 28.851C21.6389 28.851 22.0547 27.8531 24.1142 28.851C25.5206 29.531 28.4558 29.8294 28.4558 27.7503C28.4558 25.6712 28.8839 24.7222 29.1896 24.3871C29.4954 24.052 29.5859 23.4698 29.1896 23.1641C29.1896 23.1641 29.4954 22.9806 29.647 22.736C29.7987 22.4914 29.8598 22.3985 29.647 21.7576C29.4342 21.1168 29.5247 20.6569 30.0139 20.6569C30.5031 20.6569 32.2447 20.564 31.3274 19.16C30.4102 17.756 29.2801 15.5522 29.1872 15.2464C29.0942 14.9407 29.2165 14.2974 29.5541 13.4119C29.8916 12.5265 30.4444 1.15015 17.6348 1.15015C4.82509 1.15015 4.1818 11.4135 4.4264 13.3801C4.7297 15.8261 5.58824 17.9981 7.45454 20.3512C9.32083 22.7042 9.35018 25.182 8.61638 26.2827L7.88259 27.3834",
  stroke: "#121926",
  "stroke-width": "2",
  "stroke-miterlimit": "10"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }